import MediumEditor from 'medium-editor';

const DragDropExtension = MediumEditor.Extension.extend({
  name: 'dragdrop-extension',
  allowedTypes: ['image'],

  init() {
    MediumEditor.Extension.prototype.init.apply(this);
    // eslint-disable-next-line prefer-destructuring
    this.element = this.base.elements[0];
    this.subscribe('editableDrag', this.handleDrag.bind(this));
    this.subscribe('editableDrop', this.handleDrop.bind(this));
  },

  handleDrag(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
    this.addDragingClass();
    const target = event.target.classList ? event.target : event.target.parentElement;
    this.clearClassNames(target);

    if (
      event.type === 'dragover'
      && target.parentNode === this.element
      && target !== this.element
      && target.classList
      && (target.tagName === 'P' || target.tagName === 'DIV')
    ) {
      target.classList.add('medium-editor-dragover');
    }
  },

  handleDrop(event) {
    // Prevent file from opening in the current window
    event.preventDefault();
    event.stopPropagation();

    const { files } = event.dataTransfer;
    if (files) {
      this.removeDragingClass();
      if (this.isAllowedFile(files[0])) {
        this.insertImage(files);
      }
    }
  },

  isAllowedFile(file) {
    return this.allowedTypes.some(fileType => !!file.type.match(fileType));
  },

  insertNewLine(dragoverLine) {
    const newline = document.createElement('p');
    newline.innerHTML = '<br>';
    newline.classList.add('medium-insert-active');
    dragoverLine.classList.remove('medium-insert-active', 'medium-editor-dragover');
    dragoverLine.insertAdjacentElement('afterend', newline);
    MediumEditor.selection.moveCursor(document, newline);
    newline.click();
  },

  // The original code https://github.com/linkesch/medium-editor-insert-plugin/blob/master/src/js/images.js#L197
  triggerMediumInsertUploadFile(files) {
    const that = window.mediumInsertImages;
    const $file = $('<input type="file">');

    const fileUploadOptions = {
      dataType: 'json',
      add(e, data) {
        $.proxy(that, 'uploadAdd', e, data)();
      },
      done(e, data) {
        $.proxy(that, 'uploadDone', e, data)();
      },
    };

    if (new XMLHttpRequest().upload) {
      fileUploadOptions.progress = function (e, data) {
        $.proxy(that, 'uploadProgress', e, data)();
      };

      fileUploadOptions.progressall = function (e, data) {
        $.proxy(that, 'uploadProgressall', e, data)();
      };
    }

    $file.fileupload($.extend(true, {}, that.options.fileUploadOptions, fileUploadOptions));
    $file.prop('files', files);
    $file.get(0).dispatchEvent(new Event('change'));
  },

  insertImage(files) {
    const dragoverLine = this.element.querySelector('.medium-editor-dragover');

    if (!dragoverLine) {
      return;
    }

    this.insertNewLine(dragoverLine);
    this.triggerMediumInsertUploadFile(files);
  },

  addDragingClass() {
    this.element.classList.add('medium-editor-draging');
  },

  removeDragingClass() {
    this.element.classList.remove('medium-editor-draging');
  },

  clearClassNames(element) {
    const editable = MediumEditor.util.getContainerEditorElement(element);
    const existing = Array.prototype.slice.call(editable.parentElement.querySelectorAll('.medium-editor-dragover'));

    existing.forEach(el => {
      el.classList.remove('medium-editor-dragover');
    });
  },
});

export default DragDropExtension;
